/**
 * 근로기준법 제60조 기준 법정 연차 일수
 * - 1년 미만: 개근한 1개월마다 1일 (최대 11일)
 * - 1년 이상: 15일
 * - 3년 이상: 최초 1년 초과 후 매 2년마다 +1일 (최대 25일)
 * 입사일이 없거나 잘못되면 null 반환
 */
export function legalLeaveDays(hireDateStr, asOf = new Date()) {
  if (!hireDateStr) return null
  const hire = new Date(hireDateStr + 'T00:00:00')
  if (isNaN(hire)) return null

  let years = asOf.getFullYear() - hire.getFullYear()
  const anniv = new Date(hire)
  anniv.setFullYear(hire.getFullYear() + years)
  if (asOf < anniv) years -= 1

  if (years < 0) return 0
  if (years < 1) {
    let months = (asOf.getFullYear() - hire.getFullYear()) * 12 + (asOf.getMonth() - hire.getMonth())
    if (asOf.getDate() < hire.getDate()) months -= 1
    return Math.max(0, Math.min(11, months))
  }
  return Math.min(25, 15 + Math.floor((years - 1) / 2))
}

/** 입사일 기준 근속 표시용 텍스트 (예: "3년 2개월") */
export function tenureText(hireDateStr, asOf = new Date()) {
  if (!hireDateStr) return ''
  const hire = new Date(hireDateStr + 'T00:00:00')
  if (isNaN(hire)) return ''
  let months = (asOf.getFullYear() - hire.getFullYear()) * 12 + (asOf.getMonth() - hire.getMonth())
  if (asOf.getDate() < hire.getDate()) months -= 1
  if (months < 0) return '입사 전'
  const y = Math.floor(months / 12)
  const m = months % 12
  return y > 0 ? `${y}년 ${m}개월` : `${m}개월`
}
